import i18n from "i18n";
import ThreatIntelPluginConfig from "./components/ThreatIntelPluginConfig";
import {
  SpamhausEDROPAdapterDocumentation,
  SpamhausEDROPAdapterFieldSet,
  SpamhausEDROPAdapterSummary
} from "./components/adapters/spamhaus-edrop";
import {
  TorExitNodeAdapterDocumentation,
  TorExitNodeAdapterFieldSet,
  TorExitNodeAdapterSummary
} from "./components/adapters/torexitnode";
import {
  WhoisAdapterDocumentation,
  WhoisAdapterFieldSet,
  WhoisAdapterSummary
} from "./components/adapters/whois/index";
import {
  AbuseChRansomAdapterDocumentation,
  AbuseChRansomAdapterFieldSet,
  AbuseChRansomAdapterSummary
} from "./components/adapters/abusech/index";
import { OTXAdapterDocumentation, OTXAdapterFieldSet, OTXAdapterSummary } from "./components/adapters/otx";
const bindings = {
  systemConfigurations: [
    {
      component: ThreatIntelPluginConfig,
      get displayName() {
        return i18n.t("plugin_sections.threat_intelligence_lookup", { ns: "configurations" });
      },
      configType: "org.graylog.plugins.threatintel.ThreatIntelPluginConfiguration"
    }
  ],
  lookupTableAdapters: [
    {
      type: "spamhaus-edrop",
      displayName: "Spamhaus (E)DROP",
      formComponent: SpamhausEDROPAdapterFieldSet,
      summaryComponent: SpamhausEDROPAdapterSummary,
      documentationComponent: SpamhausEDROPAdapterDocumentation
    },
    {
      type: "torexitnode",
      displayName: "Tor Exit Node",
      formComponent: TorExitNodeAdapterFieldSet,
      summaryComponent: TorExitNodeAdapterSummary,
      documentationComponent: TorExitNodeAdapterDocumentation
    },
    {
      type: "whois",
      displayName: "Whois for IPs",
      formComponent: WhoisAdapterFieldSet,
      summaryComponent: WhoisAdapterSummary,
      documentationComponent: WhoisAdapterDocumentation
    },
    {
      type: "abuse-ch-ransom",
      displayName: "[Deprecated] Ransomware blocklists from abuse.ch",
      formComponent: AbuseChRansomAdapterFieldSet,
      summaryComponent: AbuseChRansomAdapterSummary,
      documentationComponent: AbuseChRansomAdapterDocumentation
    },
    {
      type: "otx-api",
      displayName: "Alienvault OTX API",
      formComponent: OTXAdapterFieldSet,
      summaryComponent: OTXAdapterSummary,
      documentationComponent: OTXAdapterDocumentation
    }
  ]
};
export default bindings;
